const tr_TR = {
    homepage_title: 'QR kodu ile CalendarTask mobil sürümünü indir',
    homepage_slogn: 'CalendarTask mobil sürüm',
    homepage_ios_download: 'App Store incelemede...',
    homepage_download: 'İndir',
    homepage_url_calendar: 'https://image.idesktopcal.com/homepage/calendar_normal_chs.png',
    homepage_url_list: 'https://image.idesktopcal.com/homepage/list_normal_chs.png',
    homepage_url_color: 'https://image.idesktopcal.com/homepage/color_normal_chs.png',

    phonedownload_title: 'QR kodu ile CalendarTask mobil sürümünü indir',
    phonedownload_slogan: 'PC ve tablet ile senkron, her yerde not alın',
    phonedownload_send_vip: 'Uygulamayı yükleyin ve VIP üyelik kazanın',
    phonedownload_screenshot: 'Ekran görüntüsü',
    phodedownload_macos: 'CalendarTask macOS sürümü',
    phodedownload_windows: 'CalendarTask Windows sürümü',
    phodedownload_otherbutton: 'Şimdi görüntüle',
    phodedownload_about: 'İletişim',
    phodedownload_copyright: '京ICP备18016017号-7',

    feature_no_ad: 'Reklamsız',
    feature_easy: 'Aylık görünüm, basit ve kolay',
    feature_reminder: 'Özel hatırlatma',
    feature_countdown: 'Geri sayım yıldönümü',

    vip_task_succ: 'Başarılı. VIP için uygulamayı indirin',
    vip_task_error: 'Alım başarısız',

    group_slogn: 'CalendarTask ekip daveti',

    tt_title: 'CalendarTask',
    tt_share_1: 'Sizinle paylaşıldı',
    tt_share_2: 'Ders programı',
    tt_share_show_1: '"CalendarTask" uygulamasıyla QR kodu tarayın, PC ve telefon gösterecek',
    tt_share_show_2: 'ders programını',
    tt_share_scan_1: 'Tarayın',
    tt_share_scan_2: '"CalendarTask" uygulamasıyla',
    tt_share_succ: 'Senkronizasyon başarılı',

    v2_copyright: 'İletişim service@xiaoweiyunfu.com<br/>Copyright © 2025 Xiaowei Cloud, Inc. Tüm hakları saklıdır.',
    v2_download_appstore: 'App Store\'da indir',
    v2_download_googleplay: 'Google Play\'de mevcut',

    v2_main_title: 'CalendarTask Mobil',
    v2_main_title_part1: 'CalendarTask',
    v2_main_title_part2: 'Mobil',
    v2_main_description: 'App Store veya Google Play\'de <span class="name">CalendarTask</span> arayın',
    v2_download_ios: 'iOS indir',
    v2_download_android: 'Android indir',
    v2_download_harmonyos: 'HarmonyOS indir',
    v2_sync_status: 'Senkronizasyon tamamlandı! 1 yüklendi, 0 indirildi',
    v2_feature_title: 'Çoklu cihaz veri senkronizasyonu',
    v2_feature_description: 'Telefon, tablet ve PC arasında senkronizasyon'
};
export default tr_TR;
